module.exports = __webpack_public_path__ + "static/media/bodyfat_icon.1079930c.svg";